import LGBillingContainer from './Container'
import LGBillsContainer from './BillingsList'

export default {
    LGBillingContainer,
    LGBillsContainer
}